import { render, staticRenderFns } from "./SiteLoader.vue?vue&type=template&id=bbc381be&scoped=true&"
import script from "./SiteLoader.vue?vue&type=script&lang=js&"
export * from "./SiteLoader.vue?vue&type=script&lang=js&"
import style0 from "./SiteLoader.vue?vue&type=style&index=0&id=bbc381be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc381be",
  null
  
)

export default component.exports